import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";
type businessTypesParams = {
  sourceTypeId: string;
};
const getBusinessTypes = async ({ sourceTypeId }: businessTypesParams) => {
  const { data } = await getData(
    `${ajaxEndpoints.GET_BUSINESS_TYPES}?sourceTypeId=${sourceTypeId}`,
  );
  return data;
};

export default function useGetBusinessTypes({
  sourceTypeId,
}: businessTypesParams) {
  return useQuery([{ sourceTypeId }, "getBusinessTypes"], getBusinessTypes);
}
